import {siteConfig} from "../siteConfig";

const nomenclatures = {
    "A": "Ala", "B": "Asx", "C": "Cys", "D": "Asp", "E": "Glu", "F": "Phe",
    "G": "Gly", "H": "His", "I": "Ile", "K": "Lys", "L": "Leu", "M": "Met",
    "N": "Asn", "P": "Pro", "Q": "Gln", "R": "Arg", "S": "Ser", "T": "Thr",
    "V": "Val", "W": "Trp", "X": "X", "Y": "Tyr", "Z": "Glx", "*": "*"
};

const complementBases = {
    "A": "T", "T": "A", "C": "G", "G": "C", "N": "N", "R": "Y",
    "Y": "R", "M": "K", "K": "M", "S": "S", "W": "W", "H": "D",
    "D": "H", "B": "V", "V": "B"
};

const mrnaCodeBases = {
    "A": "A", "T": "U", "U": "T", "C": "C", "G": "G", "N": "N",
    "R": "R", "Y": "Y", "M": "M", "K": "K", "S": "S", "W": "W",
    "H": "H", "D": "D", "B": "B", "V": "V"
};
const aminoSequenceColors = {
    "G": "Orange", "A": "Orange", "S": "Orange", "T": "Orange",
    "C": "Green", "V": "Green", "I": "Green", "L": "Green",
    "P": "Green", "F": "Green", "Y": "Green", "M": "Green",
    "W": "Green", "N": "Magenta", "Q": "Magenta", "H": "Magenta",
    "D": "Red", "E": "Red", "K": "Blue", "R": "Blue",
    "X": "White", "*": "Gray"
};

const wordings = {
    "multiple_slots": `<strong>Sorry, this operation is not allowed.</strong><br> The selected regions span over multiple <span class="text-lowercase">${siteConfig["dna_sequence_verbose_name_plural"]}</span>. Please operate on one single <span class="text-lowercase">${siteConfig["dna_sequence_verbose_name"]}</span> at a time`,
    "invalid_input": "Your input sequence contained invalid characters that were removed",
    "review_input": "Please review your input",
    "wrong_input": "Please select a region with START < END, you can specify the direction/strand in the detail view",
    "no_copy": "I can't copy to clipboard!",
    "no_copy_amino": "Selection is not copied to clipboard: verify range amino sequence to copy",
    "copied": "Selection copied to clipboard",
    "no_items": "No specific {0} found in the sequence",
    "not_editable": `<strong>Sorry, this operation is not allowed.</strong><br> This is a public <span class="text-lowercase">${siteConfig["dna_sequence_verbose_name"]}</span> and cannot be edited, to change it you may create your personal copy of it.`
};

const direction = {
    '1': "FWD",
    '2': "REV",
    '0': "--",
    '-1': "REV"
};

const annotationCodes = {
    warning: 50,
    fragment: 33,
    primer: 29,
    fragmentsClone: 51,
    mRNA: 38,
};

const colors = {
    "A": "green",
    "C": "blue",
    "G": "orange",
    "T": "red",
}

const thresholdLevels = {
    "full": 1,
    "underFontWidth": 2,
    "overFontWidth": 3,
}

const DirectionsDictionary = {
    1: "FWD",
    2: "REV",
}

const MatchingPatternColors = {
    "trim": "#d0d0d0",
    "del": "orange",
    "ins": "green",
    "mis": "red",
}


const ChromatogramDictionary = {
    0: "A",
    1: "C",
    2: "G",
    3: "T",
}

const PLACEMENTS_BELOW_ANNOTATION = [
    "top", "upper_middle", "middle", "bottom"
];

const basesOperationLabel = {
    insert: "insert-bases",
    upload: "upload-bases",
    inject: "inject-bases"
}

const severityToClassName = {
    0: 'alert-info',
    1: 'alert-warning',
    2: 'alert-orange-500',
    3: 'alert-danger',
}

const severityToColor = {
    0: 'var(--bs-info)',
    1: 'var(--bs-warning)',
    2: 'var(--bs-orange)',
    3: 'var(--bs-danger)',
}

const zoomLevels = {
    max: 20,
    mid: 12,
    min: 4,
}

const EDITOR_TYPES = {
    cloningrequest: "1",
    libraries: "2"
}

const SINGLE_NUCLEIC_ACID_TYPES = ['ssDNA', 'ssRNA'];

const Selector = {
    MODAL: '#modal',
    POPPER: '.popper',

    REST_ENZYMES_TAB: "#restEnz1",
    CODING_SEQUENCES_TAB: "#cds1",
    OTHER_ANNOTATIONS_TAB: "#textann1",
    WARNING_ANNOTATIONS_TAB: "#textwarn1",
    BIOMODULES_TAB: "#biomodules1",
    FRAGMENTS_TAB: "#fragments1",

    REFERENCE: "#referenceContainer",
    REFERENCE_LABEL: "#referenceLabel",
    REFERENCE_SEQUENCE: "#referenceContent",
    READS: "#readsContainer",

    PREVIEW: "#preview",
    OVERVIEW: "#overview",
    EDITOR: "#editor",
    STATUS_BAR: "#overview #statusbar",

    TOOLBAR: "#overview #toolbar",
    POPPER_MENU: '#popperMenu',

    TOASTS: '.toast-container',
    COPY_TO_CLIPBOARD: '.copy-to-clipboard',

    SLOT_MENU: "#editSlot",

    INSERT_MENU: "#insertMenu",
    SELECTION_MENU: "#selectionMenu",
    ANNOTATION_MENU: "#annotationMenu",

    ANNOTATIONS_ITEMS: "[data-annotation]:not([data-action=optimize])",
    STANDARD_ANNOTATION_ITEMS: "[data-annotation=annotation]",
    CODING_SEQUENCE_ANNOTATION_ITEMS: "[data-annotation=coding-sequence]",
    CODING_SEQUENCE_OPTIMIZE: "[data-action=optimize]",
    FRAGMENT_ANNOTATION_ITEMS: "[data-annotation=fragment]",

    TOGGLE_ANNOTATION: "[data-action=toggle]",
    AMINO_ACID_ACTION: ["analyze", "copy-selected"],

    SHORTCUTS_EDITOR: "[data-short-cut]",
}

export {
    nomenclatures,
    complementBases,
    mrnaCodeBases,
    aminoSequenceColors,
    wordings,
    direction,
    annotationCodes,
    colors,
    thresholdLevels,
    ChromatogramDictionary,
    DirectionsDictionary,
    MatchingPatternColors,
    PLACEMENTS_BELOW_ANNOTATION,
    basesOperationLabel,
    zoomLevels,
    EDITOR_TYPES,
    severityToClassName,
    severityToColor,
    SINGLE_NUCLEIC_ACID_TYPES,
    Selector,
}